import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	searchInputAriaLabelNonFinal: {
		defaultMessage: 'Search input',
		id: 'command-palette.common.command-palette-search-dropdown.command-palette-search-input.search-input-aria-label-non-final',
		description: 'Aria label for the command palette search input',
	},
});
